import { Model } from "./model";

export class NestedModel extends Model {
    constructor(props, attributes) {
        super(Object.assign({}, attributes));
        this.validate_props(props);
        this.parent = props.parent;
        this.value = props.value;
    }
    validate_props(props) {
        if(typeof props.parent === undefined){
            throw "parent model object not defined"
        }
        if(typeof props.value === undefined){
            throw "model value must not be empty"
        }
    }
    url() {
        return [this.parent.url(), this.value].join('/');
    }
}

